import React from 'react';
import { SectionHeading } from './SectionHeading';
import { mapFeatures } from '../data/landing';
export function MapAnatomySection() {
  return <section aria-labelledby="anatomia" className="bg-white" data-id="element-125" data-mp="3uy8ajeukpop1">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-126" data-mp="cr0wuyvrjpi0">
        <SectionHeading eyebrow="No son apuntes tradicionales" title={<>
              Cada mapa convierte información compleja en algo{' '}
              <span className="italic text-coral" data-id="element-128" data-mp="mnwzwp2w7jf6">fácil de procesar.</span>
            </>} intro="Esto es lo que vas a encontrar dentro de cada página." data-id="element-127" data-mp="8p70v3wij9o6" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-129" data-mp="werxgplla5fx">
          {mapFeatures.map(feature => <article key={feature.title} className="flex flex-col items-center rounded-2xl border border-line bg-cream-deep px-7 py-9 text-center" data-id="element-130" data-mp="rfoqgzm1tp5b">
              <span aria-hidden="true" className="text-2xl" data-id="element-131" data-mp="15g7w6031kj4b">
                {feature.icon}
              </span>
              <h3 className="mt-4 font-display text-lg font-bold leading-snug text-ink" data-id="element-132" data-mp="10hy1rrp55mjr">{feature.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-133" data-mp="1tizemdnskyo9">{feature.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}